import React from 'react';
import { Stream } from '$partials/modules';
import { Button } from '$partials/ui';
import { ArrowRightIcon } from '$partials/icon';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').Section}
 */
const Section = ({
    body,
    borderTop = true,
    documentLabel,
    documentLink,
    modules,
    standfirst,
    title,
}) => {
    // render
    return (
        <div className={borderTop ? 'border-top' : ''}>
            <div className={`col-12 flex flex-wrap mb7 md-mb9${borderTop ? ' mt7' : ''}`}>
                <div className='col-12 sm-col-6 md-col-5 mb7 sm-mb0 sm-pr3 not-empty'>
                    {(title) &&
                        <h2 className='type-style-1'>{title}</h2>
                    }
                </div>
                <div className='hide md-show col-1'/>
                <div className='col-12 sm-col-6 md-col-4'>
                    {(standfirst) &&
                        <div
                            className='rich-text type-style-3 mb6'
                            dangerouslySetInnerHTML={{ __html: standfirst }} />
                    }
                    {(body) &&
                        <div
                            className='rich-text section-body type-style-6'
                            dangerouslySetInnerHTML={{ __html: body }} />
                    }
                    {(documentLink) &&
                        <div className='mt4'>
                            <Button
                                as='a'
                                className='bg-none type-style-5 link-reset'
                                href={documentLink.url}
                                iconClassName='bg-black white button border-radius-100px p3 md-p5'
                                look='underline'
                                renderIcon={<ArrowRightIcon/>}
                                target='_blank'>
                                {documentLabel || 'Download File'}
                            </Button>
                        </div>
                    }
                </div>
            </div>
            {modules?.length > 0 && (
                <div>
                    <Stream
                        modules={modules}
                        namespace='section-module' />
                </div>
            )}
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Section;
